import React from "react";
import style from "./About.module.css";
import img1 from "../../assets/Digitalization/1.png";
import img2 from "../../assets/Digitalization/2.png";
import img3 from "../../assets/Digitalization/3.png";
import img4 from "../../assets/Digitalization/4.png";
import img5 from "../../assets/Digitalization/5.png";
import img6 from "../../assets/Digitalization/6.png";
import img7 from "../../assets/Digitalization/7.png";
import img8 from "../../assets/Digitalization/8.png";

const Digitalization = () => {
  const boxes = [
    {
      img: img1,
      alt: "Efficient Administrative Processes",
      head: "Efficient Administrative Processes",
      description:
        "Aspiron Technologies offers a unified platform to streamline key administrative functions such as student admissions, course registrations, fee management, and academic record maintenance, improving institutional efficiency.",
    },
    {
      img: img2,
      alt: "Seamless Campus Communication",
      head: "Seamless Campus Communication",
      description:
        "Aspiron Technologies’ integrated messaging and announcement tools enable smooth communication across the institution, ensuring timely updates and fostering a well-connected campus community.",
    },
    {
      img: img3,
      alt: "Enriched Student Engagement",
      head: "Enriched Student Engagement",
      description:
        "Aspiron Technologies empowers students to interact with faculty, monitor their academic progress, submit assignments, and actively participate in extracurricular activities, creating a more engaging and comprehensive educational experience.",
    },
    {
      img: img4,
      alt: "Dynamic Learning Environment",
      head: "Dynamic Learning Environment",
      description:
        "Aspiron Technologies’ Learning Management System (LMS) provides tools for content sharing, assignment tracking, online assessments, and grade management, enabling an engaging and interactive learning ecosystem.",
    },
    {
      img: img5,
      alt: "Optimized Resource Utilization",
      head: "Optimized Resource Utilization",
      description:
        "Aspiron assists institutions in efficiently managing classrooms, labs, libraries, and other resources, ensuring optimal utilization, reducing operational costs, and enhancing resource allocation.",
    },
    {
      img: img6,
      alt: "Data-driven Decision Making",
      head: "Data-driven Decision Making",
      description:
        "Aspiron Technologies assists institutions in managing resources like classrooms, labs, and libraries efficiently, ensuring optimal use, cost reduction, and improved allocation processes.",
    },
    {
      img: img7,
      alt:  "Simplified Fee Management",
      head: "Simplified Fee Management",
      description:
        "Aspiron simplifies fee collection, payment tracking, and offers online payment options, along with real-time financial reports, making fee management easier for both students and administrators.",
    },
    {
      img: img8,
      alt:  "Insight-Driven Academic Decisions",
      head: "Insight-Driven Academic Decisions",
      description:
        " With Aspiron Technologies’ analytics tools, institutions can evaluate student performance, attendance trends, and other metrics to make informed, data-driven decisions that enhance academic outcomes.",
    },
  ];

  return (
    <div className={style.traform}>
      <br />
      <br />
      <div className={style.digi_head}>
        <h2>
          "Transforming Campus Digitalization – The Key Advantage for Every
          Campus with Aspiron."
        </h2>
        <br />
        <p>
          Aspiron brings a transformative impact and a range of benefits to
          higher education institutions. With Aspiron, institutions can provide
          personalized learning experiences, equip faculty with efficient
          communication tools, and leverage data-driven insights to enhance
          outcomes.
        </p>
      </div>
      <br />
      <br />
      <div className={style.digi_boxs_cntr}>
        {boxes.map((each, index) => (
          <div className={style.digi_boxs}>
            <img src={each.img} alt="img"/>

            <b>{each.head}</b>

            <p>{each.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Digitalization;
